import { ReadonlyURLSearchParams } from 'next/navigation';

export const getAgeMin = (searchParams: ReadonlyURLSearchParams) => Number(searchParams.get('ageRangeStart'));
